export default "__VITE_ASSET__6LkUWd2J__"